import { z } from "zod";
import { privacyModeSchema } from "@/features/pulse-surveys/schemas/pulse-survey.schema";

/// Mirrors shore's PLATFORM_DEFAULT_ANONYMITY_THRESHOLD
/// (src/shared/anonymity/anonymity-threshold.service.ts): the effective floor
/// is the workspace override below, or this platform default.
export const PLATFORM_DEFAULT_ANONYMITY_THRESHOLD = 5;

export const workspaceHealthConfigSchema = z
  .object({
    defaultPrivacyMode: privacyModeSchema,
    minAnonymityThresholdOverride: z.number().int().nullable(),
    workspaceTimezone: z.string(),
  })
  .strict();
export type WorkspaceHealthConfig = z.infer<typeof workspaceHealthConfigSchema>;

export const updateWorkspaceHealthConfigSchema = z
  .object({
    defaultPrivacyMode: privacyModeSchema.optional(),
    minAnonymityThresholdOverride: z.number().int().min(2).max(50).nullable().optional(),
    workspaceTimezone: z.string().min(1).optional(),
  })
  .strict();
export type UpdateWorkspaceHealthConfig = z.infer<typeof updateWorkspaceHealthConfigSchema>;
